import { ColumnInterface } from '@shared/interfaces/column.interface'
import { ColumnsPostTradingExercisesEnum } from '../../enums/post-trading/columns-post-trading-exercises.enum'

export const ColumnsPostTradingExercisesConstant: ColumnInterface<ColumnsPostTradingExercisesEnum>[] = [
	{
		column: ColumnsPostTradingExercisesEnum.option,
		visible: true,
	},
	{
		column: ColumnsPostTradingExercisesEnum.options,
		visible: true,
	},
	{
		column: ColumnsPostTradingExercisesEnum.stocks,
		visible: true,
	},
	{
		column: ColumnsPostTradingExercisesEnum.sum,
		visible: true,
	},
	{
		column: ColumnsPostTradingExercisesEnum.price,
		visible: true,
	},
	{
		column: ColumnsPostTradingExercisesEnum.event,
		visible: true,
	},
	{
		column: ColumnsPostTradingExercisesEnum.date,
		visible: true,
	},
]
